import axios from 'axios'

//接口地址
axios.defaults.baseURL = process.env.NODE_ENV == "development" ? "/api" : window.location.origin;
//跨域
axios.defaults.withCredentials = true;
axios.defaults.headers['Content-Type'] = 'application/json;chartset=utf-8';
axios.defaults.headers['Authorization'] = getCookie('Authorization') ? getCookie('Authorization') : '';
//超时
axios.defaults.timeout = 30000;

function getCookie(name) { 
    var arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)");
    if(arr=document.cookie.match(reg)){
        return unescape(arr[2]); 
    }else{
        return null; 
    }
} 

// http请求拦截器
axios.interceptors.request.use(config => {
    return config
}, error => {
    console.log(error);
    return Promise.reject(error);
})

// http响应拦截器
axios.interceptors.response.use(response => {
    if(response.data.code == 700){
        //未登录则跳出登录页
        MessageBox({
            type: "warning",
            message: "请先登录"
        },function () {
            window.location.href = "/";
        });
    }else{
        return response.data;
    };
}, error => {
    console.log(error);
    return Promise.reject(error);
})


export default axios



// WEBPACK FOOTER //
// ./src/utils/axios.js